import _classCallCheck from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { PolygonDrawerBase } from "./PolygonDrawerBase";
export var TriangleDrawer = /*#__PURE__*/function (_PolygonDrawerBase) {
  _inherits(TriangleDrawer, _PolygonDrawerBase);
  var _super = _createSuper(TriangleDrawer);
  function TriangleDrawer() {
    _classCallCheck(this, TriangleDrawer);
    return _super.apply(this, arguments);
  }
  _createClass(TriangleDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 3;
    }
  }, {
    key: "getSidesData",
    value: function getSidesData(particle, radius) {
      return {
        count: {
          denominator: 2,
          numerator: 3
        },
        length: radius * 2
      };
    }
  }, {
    key: "getCenter",
    value: function getCenter(particle, radius) {
      return {
        x: -radius,
        y: radius / 1.66
      };
    }
  }]);
  return TriangleDrawer;
}(PolygonDrawerBase);